var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHoverLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 74,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 43.924L63 30v30.076L39 74V43.924z",
    fill: "#1066C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12L33.5 0 63 30 39 44 9 12z",
    fill: "#1D70CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.5L19.5 24v28.342L0 62.5v-29z",
    fill: "#1066C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 53l10 3v15l-10-3V53z",
    fill: "#1D70CA"
  })));
}

export default __webpack_public_path__ + "1e77ae08dab6682c9ccd51fa67713025.svg";
export { SvgHoverLogo as Component };